import React, {useState} from 'react';
import propTypes from 'prop-types';


export default function TextForm(props) {

  const [text, setText] = useState("");

  const textChangeHandler = (e)=>{
    setText(e.target.value);
  }

  const handleCopyClick = ()=>{
    var textField = document.createElement('textarea')
    textField.innerText = text;
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove();
    // alert("Copied!");
    props.showAlert("Copied to Clipboard!", "success");
    
  }


  // const handleCopyClick = ()=>{
  //   var test = document.getElementById("myBox");
  //   test.select();
  //   test.setSelectionRange(0, 9999);
  //   navigator.clipboard.writeText(text);
  //   alert("copied!");
  // }

  const handleUpClick = ()=>{
    let newText = text.toUpperCase();
    setText(newText);
    props.showAlert("Converted to Upper case", "success");
  }

  const handleLowClick = ()=>{
    let newText = text.toLowerCase();
    setText(newText);
    props.showAlert("Converted to Lower case", "success");
  }

  const handleCapitalize = ()=>{
    let mySentence = text;
    mySentence = mySentence.toLowerCase();
    mySentence = mySentence.replaceAll("\n", " ");
    let words = mySentence.split(" ");
    words = words.filter(item => item!=='');

    words = words.map((word) => {
      return word[0].toUpperCase() + word.substring(1);
    });

    // console.log(words);

    words = words.join(" ");
    
    setText(words);
    props.showAlert("Capitalized!", "success");
  }

  const handleAlternatingCapsClick = ()=>{
    let newText = text;
    let res = "";
    for(let i=0; i<=newText.length-1; i++){
      if(i%2){
        res= res + newText[i].toLowerCase();
      }
      else{
        res = res + newText[i].toUpperCase();
      }
    }
    setText(res);
    props.showAlert("Converted to Alternating caps", "success");
  }

  const handleExtraSpaces = ()=>{
    let newText = text.split(/[ ]+/);
    setText(newText.join(" "));
    props.showAlert("Extra spaces removed", "success");
  }

  const handleClearTextClick = ()=>{
    setText("");
    props.showAlert("Text cleared", "success");
  }

  return(
    <>
    <div className='container'>
      <div className="mb-3">
        <h1>{props.heading} </h1>
        <textarea className="form-control" value={text} onChange={textChangeHandler} id="myBox" rows="8"></textarea>
      </div>
        <button className='btn btn-primary m-1' onClick={handleUpClick}> UPPERCASE</button>
        <button className='btn btn-primary m-1' onClick={handleLowClick}>lowercase</button>
        <button className='btn btn-primary m-1' onClick={handleCapitalize}>Capitalize</button>
        <button className='btn btn-primary m-1' onClick={handleAlternatingCapsClick}>AlTeRnAtInG CaPs </button>
        <button className='btn btn-primary m-1' onClick={handleExtraSpaces}>Remove extra spaces </button>
        <button className='btn btn-success m-1' onClick={handleCopyClick}>Copy Text</button>
        <button className='btn btn-danger m-1' onClick={handleClearTextClick}>Clear Text </button>
        
    </div>
    <div className='container'>
      <h1>Text summary</h1>
      <p>{ text.trim().split(" ")[0]=="" ?0:text.trim().split(" ").length} words and {text.length} characters</p>
      <p>{Math.round((0.008 * text.split(" ").length* 100))/100} minutes read</p>
      <h2>Preview</h2>
      <p>{text?text:'Enter something in textbox above to preview it here'}</p>
    </div>
        
      </>
  );
}


TextForm.defaultProps = {
    heading:"textform title"
}
TextForm.propTypes = {
    heading: propTypes.string
}